// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__21WS0","title":"BackImages_title__1564c","images":"BackImages_images__2xroS"};